The response from the `createPositionOpening` mutation.
